import {
  fetchFromApi,
  handleFileResponse,
  optionsForPatchRequest,
} from './apiUtils';

const basePath = '/v1/obligation';

const getObligationXsd = obligationId =>
  fetchFromApi(`${basePath}/${obligationId}/xsd`, {}, handleFileResponse);

const changeObligationReporter = (obligationId, user) =>
  fetchFromApi(
    `${basePath}/${obligationId}/reporter`,
    optionsForPatchRequest(user)
  );

export default {
  getObligationXsd,
  changeObligationReporter,
};
